var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisionBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 335,
    height: 74,
    viewBox: "0 0 335 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 335,
    height: 74,
    fill: "url(#paint0_linear_19577_32537)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19577_32537",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 335,
    height: 74
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 335,
    height: 74,
    fill: "#E9F7EF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19577_32537)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M280.976 11.3406C283.367 12.7214 286.425 11.902 287.806 9.51052C289.186 7.11906 288.367 4.0611 285.976 2.68039L280.976 11.3406ZM215.027 11.425L211.935 7.49564C211.006 8.22695 210.366 9.264 210.128 10.4226L215.027 11.425ZM316.784 72.5637C319.031 70.958 319.55 67.835 317.945 65.5885C316.339 63.342 313.216 62.8225 310.969 64.4283L316.784 72.5637ZM285.976 2.68039C250.36 -17.8821 221.482 -0.0165675 211.935 7.49564L218.119 15.3543C226.463 8.78813 250.691 -6.14425 280.976 11.3406L285.976 2.68039ZM210.128 10.4226C207.892 21.352 207.36 56.7055 242.928 77.2406L247.928 68.5804C217.596 51.0681 218.142 21.1435 219.925 12.4274L210.128 10.4226ZM242.928 77.2406C260.527 87.4013 276.321 88.3143 289.18 85.5067C301.883 82.7332 311.427 76.3933 316.784 72.5637L310.969 64.4283C305.938 68.0246 297.733 73.4038 287.046 75.7369C276.516 78.0361 263.28 77.4434 247.928 68.5804L242.928 77.2406ZM302.942 24.0242L335.892 43.0479L340.892 34.3876L307.942 15.3639L302.942 24.0242ZM327.099 10.2298L308.075 43.1798L316.736 48.1798L335.759 15.2298L327.099 10.2298ZM271.105 43.8028C268.983 47.4773 264.285 48.7362 260.61 46.6148L255.61 55.275C264.067 60.1579 274.882 57.2602 279.765 48.8028L271.105 43.8028ZM260.61 46.6148C256.936 44.4933 255.677 39.7948 257.798 36.1204L249.138 31.1204C244.255 39.5777 247.153 50.3922 255.61 55.275L260.61 46.6148ZM257.798 36.1204C259.92 32.4459 264.618 31.1869 268.293 33.3084L273.293 24.6481C264.835 19.7652 254.021 22.663 249.138 31.1204L257.798 36.1204ZM268.293 33.3084C271.967 35.4298 273.226 40.1283 271.105 43.8028L279.765 48.8028C284.648 40.3454 281.75 29.531 273.293 24.6481L268.293 33.3084Z",
    fill: "#7C5AD7"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.06,
    cx: 85,
    cy: 102,
    r: 102,
    fill: "#9B7DEC"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.06,
    cx: 265,
    cy: 40,
    r: 30.9,
    stroke: "url(#paint1_linear_19577_32537)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M292.9 40C292.9 55.4087 280.409 67.9 265 67.9C249.591 67.9 237.1 55.4087 237.1 40C237.1 24.5913 249.591 12.1 265 12.1C280.409 12.1 292.9 24.5913 292.9 40Z",
    fill: "#6544C6",
    fillOpacity: 0.5,
    stroke: "url(#paint2_linear_19577_32537)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M289.9 40C289.9 53.7519 278.752 64.9 265 64.9C251.248 64.9 240.1 53.7519 240.1 40C240.1 26.2481 251.248 15.1 265 15.1C278.752 15.1 289.9 26.2481 289.9 40Z",
    fill: "#6544C6",
    fillOpacity: 0.5,
    stroke: "url(#paint3_linear_19577_32537)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M286.9 40C286.9 52.095 277.095 61.9 265 61.9C252.905 61.9 243.1 52.095 243.1 40C243.1 27.905 252.905 18.1 265 18.1C277.095 18.1 286.9 27.905 286.9 40Z",
    fill: "#6544C6",
    fillOpacity: 0.5,
    stroke: "url(#paint4_linear_19577_32537)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M283.9 40C283.9 50.4382 275.438 58.9 265 58.9C254.562 58.9 246.1 50.4382 246.1 40C246.1 29.5618 254.562 21.1 265 21.1C275.438 21.1 283.9 29.5618 283.9 40Z",
    fill: "#6544C6",
    fillOpacity: 0.5,
    stroke: "url(#paint5_linear_19577_32537)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M279.9 40.5C279.9 49.0052 273.005 55.9 264.5 55.9C255.995 55.9 249.1 49.0052 249.1 40.5C249.1 31.9948 255.995 25.1 264.5 25.1C273.005 25.1 279.9 31.9948 279.9 40.5Z",
    fill: "#6544C6",
    fillOpacity: 0.5,
    stroke: "url(#paint6_linear_19577_32537)",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19577_32537",
    x1: -9.9296e-7,
    y1: 31.7143,
    x2: 294.149,
    y2: 141.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6C3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_19577_32537",
    x1: 292.201,
    y1: 58.2353,
    x2: 249.196,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAA02B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD595"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_19577_32537",
    x1: 289.569,
    y1: 56.4706,
    x2: 250.725,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAA02B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD595"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_19577_32537",
    x1: 286.936,
    y1: 54.7059,
    x2: 252.255,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAA02B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD595"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_19577_32537",
    x1: 284.304,
    y1: 52.9412,
    x2: 253.784,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAA02B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD595"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_19577_32537",
    x1: 281.672,
    y1: 51.1765,
    x2: 255.314,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAA02B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD595"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_19577_32537",
    x1: 278.1,
    y1: 49.6176,
    x2: 256.598,
    y2: 40.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAA02B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD595"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisionBackground);
export default __webpack_public_path__ + "static/media/VisionBackground.e4e5386f1502d9098fd9c6b256abb7bf.svg";
export { ForwardRef as ReactComponent };